import { EXPLORE_FILTER_TYPE } from './use-experience-filter';
import useSetFilter, { TypeKey } from './use-set-filter';

const useSetType = () => useSetFilter<TypeKey | undefined>(EXPLORE_FILTER_TYPE);

export default useSetType;
